import { TasksListView } from "./TasksListView";

export function AllTasksPage() {
  return <TasksListView title="All Tasks" scope="all" showAssigneeFilter showExport backTo="/tasks" />;
}
